import { render, staticRenderFns } from "./VacancyAssignSolicitant.vue?vue&type=template&id=749b24b0"
import script from "./VacancyAssignSolicitant.vue?vue&type=script&lang=js"
export * from "./VacancyAssignSolicitant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports